/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React from 'react';
import Transform from '../../../../data-transform';
const Poll = ({ data, container }) => {
  return (
    <div className="pollCard">
      <Transform container={container} data={data} iscollection={true} source="aws" />
    </div>
  );
};
export default Poll;
